<rt-integration-item
  [isComingSoon]="!enabled"
  [heading]="'Zapier'"
  [isIntegrationLoaded]="!loading"
  [hasIntegration]="active"
  [teamIntegrationsCount]="teamIntegrationsCount"
  [isRemoving]="state.deauthorizeLoading"
  (integrate)="authorize()"
  (remove)="deauthorize()"
>
  <rt-icon icon name="zapier" size="large"> </rt-icon>

  <div description>
    {{ 'app.settings.integrations.zapier.description' | translate }}
  </div>
</rt-integration-item>
